<!-- 게시판글 표현 -->
<template>

    <swiper
        effect="fade"
        :slides-per-view="1"
        :space-between="0"
        :loop="true"   
        :autoplay="{ delay: slide_delay,disableOnInteraction:false}"        
        :style="{width:slide_width,height:slide_height}" 
        v-if="getbanners.length > 0"
    >
        <template v-for="(banner, index) in getbanners" :key="index" >
            <swiper-slide >
                
                <div class="banner_image" 
                :style="{backgroundImage:`url(/storage/${banner.image})`,width:slide_width,height:slide_height, }" 
                    @click="jumpLink(banner.link, banner.insite)"                
                    >
                    <div class="banner_description" :class="mode" v-if="banner.description">                      
                        <span>{{banner.description}}</span>       
                    </div>    
                </div>    
            </swiper-slide>
        </template>     
    </swiper>
    <div v-else :style="{width:slide_width,height:slide_height }" class="banner_blank">
        배너광고 신청
    </div>

</template>
<script>
  // import Swiper core and required modules
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay,EffectFade  } from 'swiper';

  // Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';
  // install Swiper modules
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay,EffectFade]);

  // Import Swiper styles
export default {
    name:'BannerSlide',
    props:[
        'banner_pos','slide_width','slide_height','slide_delay','mode','isMobile'
    ],
    data(){
        return{
            mainview:null
        }
    },     
    components: {        
        Swiper,
        SwiperSlide,
    },
    computed:{
        getbanners(){
            if(this.$store.state.banner.banners){
                return this.$store.state.banner.banners.filter((banner)=>banner.pos ===this.banner_pos);
                //return this.$store.state.banner.banners.find((banner)=>banner.pos ===this.banner_pos);
            }else{
                return false;
            }
            
        }
    },
    methods: {
        // onSwiper(swiper) {
        //     console.log(swiper);
        // },
        // onSlideChange() {
        //     console.log('slide change');        
        // },   
         jumpLink(url, insite)
        {
            if(url)
            {
                //모바일 버전일때는 주소값 변경
                if(this.isMobile)
                {
                    let str = this.$store.state.serverPath;
                   
                    url = url.replace(str+'/main','/m');   
                    this.$router.push(url);                 
                }else{
                    if(insite ===1)
                    {
                        //기존창
                        location.href=url;
                        // alert(url);
                        // this.$router.push(url);
                    }else{
                        //새로운 창
                        window.open(url);
                    }       
                }
                        
            }
            
        }  
        
    },
};
</script>
<style lang="scss" >
@import '@/assets/swiper/components/effect-fade/effect-fade.scss';
.banner_blank{
    background:#d1d1d1;
    display: flex;
    font-size:20px;
    align-items: center;
    justify-content: center;
    color: rgb(107, 107, 107);
}
.swiper-slide{     
    .banner_image{
        width:100%;
        height:100%;
        background-size: cover;
        background-position: center;
        display:flex;
        flex-direction:column;
        justify-content: flex-end;
        cursor: pointer;
         .banner_description{   
            font-family: '맑은고딕';       
            font-size:20px;  
            font-weight:bold;
            padding:10px;    
            height:80px;    
            text-align: center;  
            color:#fff;            
            span{
                background:#000;   
                padding:0 20px;
                border-radius: 10px;                 
            } 
        }
        .black{
            color:#000;
            span{
                background:#fff;   
                padding:0 20px;
                border-radius: 10px; 
            } 
        }
    }
}
.swiper-button-prev{
    opacity: 0.1;
}
.swiper-button-next{
    opacity: 0.1;   
}
.swiper-button-prev:hover
{
    opacity:.8;  
    transition:0.5s;
}
.swiper-button-next:hover{
    opacity: 0.8;   
    transition:0.5s;
}
</style>